import React from "react"
import { Loader } from "semantic-ui-react"
import queryString from "qs"
import settingStore from "stores/settingStore"
import { parseOrderMode, confirmOrderModeChange, applyOrderMode } from "../shop/orderMode"

// Zwischenseite /ordermode/?mode=...&to=... (siehe rewriteInitialOrderModeUrl / OrderModeLinkHandler)
export default class OrderModeSwitchPage extends React.Component {

  componentDidMount() {
    const { history, location } = this.props
    const { mode, to } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    const wantedMode = parseOrderMode( mode )
    // nur shop-interne Pfade als Ziel zulassen
    const target = typeof to === "string" && to.startsWith( "/" ) && !to.startsWith( "//" ) ? to : "/"

    if ( !wantedMode || wantedMode === settingStore.get( "orderMode" ) ) return history.replace( target )

    confirmOrderModeChange( wantedMode )
      .then( confirmed => {
        if ( confirmed ) {
          applyOrderMode( wantedMode )
          history.replace( target )
        } else {
          history.replace( "/" )
        }
      } )
  }

  render() {
    return <div className="bg-silver min-vh-100 flex flex-column justify-center">
      <Loader active inline="centered"/>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/pages/OrderModeSwitchPage.js